export enum AccountType {
  Control = 1,
  Collection = 2,
  Loan = 3,
  Buffer = 4,
  Unidentified = 5,
}
